import React, { useMemo, useState} from 'react'
import styled from "styled-components";
import classnames from "classnames";
import { useSquad } from '../../hooks/useSquad'
import Modal from '../../components/Modal/Modal'
import Spinner from '../../components/Spinner'
import genieImage from '../../assets/imgs/nfts/genie.png'
import knightImage from '../../assets/imgs/nfts/knight.png'
import SynthModal from './SynthModal'
import SynthResult from './SynthResult'
import { SYNTH_CONFIG_GENIE, SYNTH_CONFIG_KNIGHT } from './config'
import {usePrevent} from "../../hooks/usePrevent";

const nftConfig = [
  {
    image: genieImage,
    title: 'Cyber Genie',
    desc: 'Full Squad but King of Combat /Cheetah Legend burnt',
    className: 'nft-genie',
    synth: SYNTH_CONFIG_GENIE,
  },
  {
    image: knightImage,
    title: 'Neon Knight',
    desc: 'Full Squad burnt',
    className: 'nft-knight',
    synth: SYNTH_CONFIG_KNIGHT
  }
]

export default function Synth() {
  const [shouldShowModal, setShowModal] = useState(false);
  const [shouldShowResult, setShowResult] = useState(false);
  const {loading , squads, reload} = useSquad()
  usePrevent()
  const handleMint = (tokenId) => {
    setShowModal(false)
    setShowResult(tokenId)
    reload()
  }

  return (
    <Wrapper>
      <div className="container">
        {
          nftConfig.map((config) => {
            return <div className="card-container" key={config.className}>
              <div className={classnames('card', config.className)}>
                <h3 className="card-title">{config.title}</h3>
                <div className="card-img">
                  <img src={config.image} />
                </div>
                <button className="btn-mint" onClick={() => setShowModal(config)}>Mint Now</button>
              </div>
            </div>
          })
        }
      </div>
      <Modal isOpen={!!shouldShowModal} handleClose={() => setShowModal(false)}>
        {
          !!shouldShowModal && <SynthModal onMint={handleMint} loading={loading} config={shouldShowModal} squads={squads}/>
        }
      </Modal>
      <Modal isOpen={!!shouldShowResult} handleClose={() => setShowResult(false)}>
        {
          !!shouldShowResult && <SynthResult tokenId={shouldShowResult} onClose={() => setShowResult(false)}/>
        }
      </Modal>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  .container {
    display:flex;
    align-items: center;
    justify-content: center;
    gap: 40px;
    padding: 54px 0 0 0;
  }
  
  .card-container {
     width: 364px;
     height: 524px;
     display:flex;
     align-items: center;
     justify-content: center;
     position: relative;
     overflow: hidden;
     border-radius: 20px;
  }
  
   .btn-mint {
    font-size: 16px;
    width: 246px;
    height: 48px;
    border: 0 none;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    cursor: pointer;
    transition: all ease .3s;
    position: relative;
    overflow: hidden;
    
    &[disabled] {
        opacity: .5;
        cursor: not-allowed;
    }
    
    &:not([disabled]):before {
        position: absolute;
        display: block;
        content: ' ';
        top: -30px;
        left: -70px;
        width: 35px;
        height: 115px;
        z-index: 2;
        background: rgba(255, 255, 255, 0.3);
        transform: rotate(45deg);
    }
    
    &:not([disabled]):hover:before {
      animation: flash 1.5s linear infinite;
    }
  }
  
  .card {
    width: 340px;
    height: 480px;
    background: #161616;
    border-radius: 20px;
    display:flex;
    align-items: center;
    justify-content: start;
    flex-direction: column;
    gap: 12px;
    padding: 30px 36px;
    box-sizing: border-box;
    transition: all ease .3s;
    position: relative;
    z-index: 2;
    
    .card-title {
      font-size: 24px;
      font-weight: 400;
      text-shadow: 0px 0px 10px rgba(255, 255, 255, 0.2);
    }
    
    .card-desc {
      font-size: 18px;
      line-height: 24px;
      height: 48px;
      width: 100%;
    }
    
    .card-img {
      width: 268px;
      height: 268px;
      border-radius: 20px;
      overflow: hidden;
      transition: all ease .3s;
      margin-bottom: 50px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    
    &:hover {
       width: 360px;
       height: 520px;
       
       .card-img {
          width: 288px;
          height: 288px;
       }
       
       .btn-mint {
           width: 288px;
       }
    }
  }
  
  .card-container:hover:before{
    content: "";
    height: 900px;
    width: 900px;
    position: absolute;
    background: conic-gradient(
        #fd004c,
        #fe9000,
        #fff020,
        #3edf4b,
        #3363ff,
        #b102b7,
        #fd004c
    );
    transform-origin: center center;
    left: -300px;
    top:  -300px;
    animation: spin 5s infinite linear, appear 1s ease ;
  }
  
  .card-container:hover:after{
      content: "";
      position: absolute;
      background-color: #1c1b29;
      top: 2px;
      left: 2px;
      right: 2px;
      bottom: 2px;
      border-radius: 20px;
      color: #ffffff;
      font-size: 20px;
      letter-spacing: 6px;
      display: grid;
      place-items: center;
      background: #161616;
      animation: appear .5s ease;
  }
  
  
  .nft-genie {
    .card-title {
      background: linear-gradient(95.27deg, #F6442D 9.01%, #FFFDC5 35.94%, #00A4FF 64.12%, #00D9A2 89.8%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }
    .btn-mint {
      background: linear-gradient(96.65deg, #FF7F72 9.48%, #EBE9B6 39.65%, #6DBBE6 73.13%, #78FFDD 100%);
    }
  }

  .nft-knight {
    .card-title {
      background: linear-gradient(96.65deg, #7AFF35 9.48%, #51EAFF 30.22%, #FF58C6 52.85%, #8459FF 95.21%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }
    .btn-mint {
      background: linear-gradient(96.65deg, #D5FFBF 9.48%, #8EECF9 40.71%, #FFADFD 70.77%, #9A7EF5 95.21%);
    }
  }
  
  @keyframes spin{
      100%{
          transform: rotate(-360deg);
      }
  }
  
  @keyframes appear{
      0% {
        opacity: 0;
      }
      100%{
          opacity: 1;
      }
  }
  
  @keyframes flash {
  100% {
    left: 1000px; } }
 
`;
